export const SPEEDY_SOURCES = {
    RH: 'RH',
    RH_INTERVIEW_SCHEDULE: 'RH_INTERVIEW_SCHEDULE',
    MANIFEST_INTERVIEW_SCHEDULE: 'MANIFEST_INTERVIEW_SCHEDULE',
    AMS: 'AMS',
}